/* eslint-disable import/first */

import { configureSentry } from './src/sentry'

const bodyElement = document.querySelector('body')

if (bodyElement && bodyElement.dataset.sentry) {
  try {
    const options = JSON.parse(bodyElement.dataset.sentry)
    configureSentry(options)
  } catch (error) {
    console.error(error)
  }
}

// Import just what we need
import 'bootstrap/js/dist/alert'
// import "bootstrap/js/dist/button"
import 'bootstrap/js/dist/carousel'
import 'bootstrap/js/dist/collapse'
import 'bootstrap/js/dist/dropdown'
// import "bootstrap/js/dist/modal"
import 'bootstrap/js/dist/popover'
// import "bootstrap/js/dist/scrollspy"
// import "bootstrap/js/dist/tab"
import 'bootstrap/js/dist/toast'
import 'bootstrap/js/dist/tooltip'

import 'htmx.org'

import './main.scss'
import './src/index'
